import { Box, SvgIcon } from '@mui/material'
import React from 'react'

export default function InputAdornmentSVGWrapper(props) {
  return (
    <Box
      sx={{
        w: '34px',
        h: '34px',
        p: '6px',
        ml: '6px',
        position: 'absolute',
        zIndex: '1',
        // background: 'white',
        // boxShadow: '0px 4px 30px 0px #A1A1A140',
        // borderRadius: 100,
      }}
    >
      <SvgIcon sx={{ fontSize: 34, textAlign: 'center' }} viewBox={'0 0 34 34'}>
        {props.children}
      </SvgIcon>
    </Box>
  )
}
